import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

const MakeupFormLayout = () => {
    return (
        <Box sx={{
            height: '100vh',
            width: '100%',
            overflowY: 'auto'
        }}>
            <Outlet />
        </Box>
    );
};

export default MakeupFormLayout;
